// src/components/Register.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getAuth,
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from 'firebase/auth';
import { LOGIN_URL } from '../config';
import './Register.css';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
  });

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const auth = getAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    // 🔐 Basic validation
    if (formData.password !== formData.confirmPassword) {
      setErrorMessage("Passwords don't match. Try again.");
      return;
    }

    const passwordPattern =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*.,])[A-Za-z\d!@#$%^&*.,]{8,}$/;

    if (!passwordPattern.test(formData.password)) {
      setErrorMessage(
        'Password must be at least 8 characters, include one uppercase letter, one number, and one special character.'
      );
      return;
    }

    setErrorMessage('');
    setSuccessMessage('');
    setLoading(true);

    try {
      // 1️⃣ Create Firebase Auth user
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email.trim().toLowerCase(),
        formData.password
      );

      const user = userCredential.user;

      // 2️⃣ Send verification email
      await sendEmailVerification(user, {
        url: LOGIN_URL,
      });

      // ✅ Success
      setSuccessMessage(
        'A verification email has been sent to your email address. Please verify it before logging in. If you do not see the email, please check your spam or junk folder.'
      );

    } catch (error) {
      console.error('Registration error:', error);
      setErrorMessage(error.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <form onSubmit={handleSubmit}>

        <img
          src={`${process.env.PUBLIC_URL}/images/VSN-Icon-White-Cropped.png`}
          alt="VSN"
          className="login-logo"
        />

        <h2>Create your account</h2>

        <label>Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          autoComplete="email"
          disabled={loading}
        />

        <label>Password</label>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          autoComplete="new-password"
          disabled={loading}
        />

        <label>Confirm Password</label>
        <input
          type="password"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          required
          autoComplete="new-password"
          disabled={loading}
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Creating account…' : 'Register'}
        </button>

        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        <p>
          Already verified your email?
          <button type="button" onClick={() => navigate('/login')}>
            Login here
          </button>
        </p>

      </form>
    </div>
  );
};

export default Register;




